import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_QUEUE = "GET_LIST_QUEUE";
export const GET_LIST_QUEUE_ERROR = "GET_LIST_QUEUE_ERROR";
export const GET_LIST_QUEUE_SUCCESS = "GET_LIST_QUEUE_SUCCESS";

export const DELETE_QUEUE = "DELETE_QUEUE";
export const DELETE_QUEUE_ERROR = "DELETE_QUEUE_ERROR";
export const DELETE_QUEUE_SUCCESS = "DELETE_QUEUE_SUCCESS";

export const EDIT_QUEUE = "EDIT_QUEUE";
export const EDIT_QUEUE_SUCCESS = "EDIT_QUEUE_SUCCESS";
export const EDIT_QUEUE_ERROR = "EDIT_QUEUE_ERROR";

export const ADD_QUEUE = "ADD_QUEUE";
export const ADD_QUEUE_SUCCESS = "ADD_QUEUE_SUCCESS";
export const ADD_QUEUE_ERROR = "ADD_QUEUE_ERROR";

export const COUNT_QUEUE = "COUNT_QUEUE";
export const COUNT_QUEUE_SUCCESS = "COUNT_QUEUE_SUCCESS";
export const COUNT_QUEUE_ERROR = "COUNT_QUEUE_ERROR";
/**
 * Reducer
 */

const initialState = {
  queue: [],
  error: false,
  count: 0,
  loading: false,
};

export const queueReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_QUEUE:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_QUEUE_SUCCESS:
      return {
        ...state,
        loading: false,
        queue: action.payload,
      };
    case GET_LIST_QUEUE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    //delete list
    case DELETE_QUEUE:
      return {
        ...state,
        loading: true,
      };
    case DELETE_QUEUE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_QUEUE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    //EDIT_QUEUE
    case EDIT_QUEUE:
      return {
        ...state,
        loading: true,
      };
    case EDIT_QUEUE_SUCCESS: {
      const newData = state.queue.filter((item) => item.id !== action.data.id);
      return {
        ...state,
        newData,
        loading: false,
      };
    }
    case EDIT_QUEUE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    //add
    case ADD_QUEUE:
      return {
        ...state,
        loading: true,
      };
    case ADD_QUEUE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADD_QUEUE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    //count
    case COUNT_QUEUE:
      return {
        ...state,
      };
    case COUNT_QUEUE_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_QUEUE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListQueue = (order, limit, skip, where) => ({
  type: GET_LIST_QUEUE,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countQueue = (where) => ({
  type: COUNT_QUEUE,
  data: {
    where,
  },
});

export const deleteQueue = (id) => ({
  type: DELETE_QUEUE,
  data: {
    id,
  },
});

export const editQueue = (id, data, note, members, subOrg) => ({
  type: EDIT_QUEUE,
  data: {
    id,
    data,
    note,
    members,
    subOrg,
  },
});

export const addQueue = (data, note, members, subOrg) => ({
  type: ADD_QUEUE,
  data: {
    data,
    note,
    members,
    subOrg,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListQueue,
      deleteQueue,
      editQueue,
      addQueue,
      countQueue,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListQueueApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/cloud-pbx/queue", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countQueueApi = (where) => {
  return apiCaller.getData("/cloud-pbx/queue/count", { ...where });
};

const deleteQueueApi = (id) => {
  return apiCaller.del(`/cloud-pbx/queue/${id}`);
};

const addQueueApi = (data, note, members, subOrg) => {
  return apiCaller.post("/cloud-pbx/queue", { ...data, note, members, subOrg });
};

const editQueueApi = (id, data, note, members, subOrg) => {
  return apiCaller.put(`/cloud-pbx/queue/${id}`, {
    ...data,
    note,
    members,
    subOrg,
  });
};

/**
 * sagas
 */

export const getListQueueFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_QUEUE);
    try {
      const res = yield call(
        getListQueueApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_QUEUE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_QUEUE_ERROR, error });
    }
  }
};

export const deleteQueueFlow = function* () {
  while (true) {
    const action = yield take(DELETE_QUEUE);
    try {
      const res = yield call(deleteQueueApi, action.data.id);
      yield put({ type: DELETE_QUEUE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: DELETE_QUEUE_ERROR, error });
    }
  }
};
export const editQueueFlow = function* () {
  while (true) {
    const action = yield take(EDIT_QUEUE);
    try {
      const res = yield call(
        editQueueApi,
        action.data.id,
        action.data.data,
        action.data.note,
        action.data.members,
        action.data.subOrg
      );
      yield put({ type: EDIT_QUEUE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: EDIT_QUEUE_ERROR, error });
    }
  }
};
export const addQueueFlow = function* () {
  while (true) {
    const action = yield take(ADD_QUEUE);
    try {
      const res = yield call(
        addQueueApi,
        action.data.data,
        action.data.note,
        action.data.members,
        action.data.subOrg
      );
      yield put({ type: ADD_QUEUE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: ADD_QUEUE_ERROR, error });
    }
  }
};

export const countQueueFlow = function* () {
  while (true) {
    const action = yield take(COUNT_QUEUE);
    try {
      const res = yield call(countQueueApi, action.data.where);
      yield put({ type: COUNT_QUEUE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: COUNT_QUEUE_ERROR, error });
    }
  }
};
